module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_8017.1383c8ae.png";